import React from 'react';
import { SavedLocation } from '../types/locationState';
import StatusDisplay from './StatusDisplay';
import './LocationForm.css';

interface LocationFormProps {
  locationName: string;
  radius: number;
  isCheckedIn: boolean;
  isWithinRadius: boolean;
  checkInTime: Date | null;
  lastAction: string;
  onLocationNameChange: (name: string) => void;
  onRadiusChange: (radius: number) => void;
  onTimeAction: (action: 'in' | 'out') => void;
  onSubmit: (e: React.FormEvent) => void;
  savedLocation: SavedLocation | null;
  savedLocations: SavedLocation[];
  showAddLocation: boolean;
  onToggleAddLocation: () => void;
  onSelectLocation: (locationId: string) => Promise<void>;
}

const LocationForm: React.FC<LocationFormProps> = ({
  locationName,
  radius,
  isCheckedIn,
  isWithinRadius,
  checkInTime,
  lastAction,
  onLocationNameChange,
  onRadiusChange,
  onTimeAction,
  onSubmit,
  savedLocation,
  savedLocations,
  showAddLocation,
  onToggleAddLocation,
  onSelectLocation
}) => {
  return (
    <div className="location-form">
      <div className="saved-locations">
        <h3>Saved Locations</h3>
        <div className="location-buttons">
          {savedLocations.map((location) => (
            <button
              key={location.id}
              type="button"
              className={`location-btn ${location.is_active ? 'active' : ''}`}
              onClick={() => onSelectLocation(location.id)}
            >
              {location.name}
            </button>
          ))}
        </div>
        <button 
          type="button" 
          className="add-location-btn"
          onClick={onToggleAddLocation}
        >
          {showAddLocation ? '− Cancel' : '+ Add New Location'}
        </button>
      </div>

      {showAddLocation && (
        <form onSubmit={onSubmit}>
          <div className="input-group">
            <label htmlFor="location">Location Name</label>
            <input
              type="text"
              id="location"
              value={locationName}
              onChange={(e) => onLocationNameChange(e.target.value)}
              placeholder="e.g., Work, School"
              required
            />
        </div>

        <div className="input-group">
          <label htmlFor="radius">Radius (meters)</label>
          <input
            type="number"
            id="radius"
            value={radius}
            onChange={(e) => onRadiusChange(Math.max(50, Math.min(500, Number(e.target.value))))}
            min="50"
            max="500"
            required
          />
          <div className="radius-helper">
            Min: 50m, Max: 500m
          </div>
        </div>


        <button 
          type="submit" 
          className="save-btn"
        >
          Save New Location
        </button>
      </form>
      )}

      <StatusDisplay
        isCheckedIn={isCheckedIn}
        isWithinRadius={isWithinRadius}
        checkInTime={checkInTime}
        lastAction={lastAction}
        savedLocation={savedLocation}
        onTimeAction={onTimeAction}
      />


    </div>
  );
};

export default LocationForm;
